import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { UserSession } from '@mem-shared/user-session';
import { UtilService } from '@mem-shared/util.service';

@Component({
  selector: 'mem-logoutredirect',
  templateUrl: './logoutredirect.component.html',
  styleUrls: ['./logoutredirect.component.scss']
})
export class LogoutredirectComponent implements OnInit {

  constructor(
    private router: Router,
    private userSession: UserSession,
    private utilSvc: UtilService
  ) { }

  ngOnInit() {

  }
  goPublicHome() {
    const env = this.utilSvc.getEnvName();
    const zenv = this.userSession.getSession('zenv');

    if (this.userSession.getLocalStorageItem('sourcePortal') == 'MEMBER') {
      window.location.href = window.location.origin;
    } else {
      if (env === 'tt') {
        if (zenv && zenv === 'sit') {
          window.location.href = 'https://carefirstmedicaresp.sit.crfs.use1.iws-nonprod.zipari.net';
        } else {
          window.location.href = 'https://carefirstmedicaresp.pit.crfs.use1.iws-nonprod.zipari.net';
        }
      }
      else if (env === 'uat') {
        if (zenv && zenv === 'prod') {
          window.location.href = 'https://shop.carefirst.com';
        } else {
          window.location.href = 'https://shop-uat.carefirst.com';
        }
      }
      else {
        window.location.href = 'https://shop.carefirst.com';
      }
    }

  }
  goToLogin() {
    this.router.navigate(['/login'], { queryParams: { sourcePortal: this.userSession.getLocalStorageItem('sourcePortal') } });
  }


}



// WEBPACK FOOTER //
// ./src/app/new-login-widget/logoutredirect/logoutredirect.component.ts